<p>input-footer works!</p>
